module.exports = __webpack_public_path__ + "img/0ccb7e7.jpg";